import React, { useEffect, useRef, memo } from 'react';
import { axisBottom, axisLeft, select, format } from 'd3';
import { XAxis, XAxisGrid, YAxis, YAxisGrid } from './styles';
import theme from '@cubeyou-team/hx-theme';

const LineChartAxes = (props) => {
  const {
    highlightTicks,
    chartWidth,
    chartHeight,
    padding,
    xScale,
    yScale,
    yDelta,
    allowDecimalTicks,
    rotateXAxisLabels,
    onXAxisMouseOver,
    onXAxisMouseLeave
  } = props;

  const xAxisRef = useRef(null);
  const xAxisGridRef = useRef(null);
  const yAxisRef = useRef(null);
  const yAxisGridRef = useRef(null);

  useEffect(() => {
    const xAxis = axisBottom()
      .scale(xScale)
      .ticks(chartWidth / 100);
    const bottom = select(xAxisRef.current).call(xAxis);

    if (rotateXAxisLabels)
      bottom
        .selectAll('text')
        .attr('dx', '-1.5em')
        .attr('dy', '1.5em')
        .attr('transform', 'rotate(-45)');

    const xAxisGrid = axisBottom()
      .scale(xScale)
      .tickSize(-(chartHeight - 2 * padding))
      .tickFormat('')
      .ticks(chartWidth / 100);
    select(xAxisGridRef.current)
      .call(xAxisGrid)
      .selectAll('.tick')
      .each(function () {
        const d = select(this);
        const h = Math.abs(d.select('line').attr('y2'));
        d.append('rect')
          .attr('width', 20)
          .attr('height', h)
          .attr('x', -10)
          .attr('y', d.select('line').attr('y2'))
          .style('pointer-events', 'visible');
      })
      .on('mousemove', function (event, item) {
        if (highlightTicks) {
          const d = select(event.currentTarget);
          d.select('line')
            .style('stroke', theme.colors.dark_lighter)
            .style('stroke-width', 3);
          onXAxisMouseOver(event, item);
        }
      })
      .on('mouseleave', function (event) {
        if (highlightTicks) {
          const d = select(event.currentTarget);
          d.select('line')
            .style('stroke', theme.colors.light_darker_1)
            .style('stroke-width', 1);
          onXAxisMouseLeave(event);
        }
      });

    const yTicks = allowDecimalTicks
      ? chartHeight / 50
      : Math.min(yDelta, chartHeight / 50);

    const yAxis = axisLeft()
      .scale(yScale)
      .tickFormat(format('~s'))
      .ticks(yTicks);
    select(yAxisRef.current).call(yAxis);

    const yAxisGrid = axisLeft()
      .scale(yScale)
      .tickSize(-(chartWidth - 2 * padding))
      .tickFormat('')
      .ticks(yTicks);
    select(yAxisGridRef.current).call(yAxisGrid);
  }, [props]);

  return (
    <g>
      <XAxis
        ref={xAxisRef}
        transform={`translate(0, ${chartHeight - padding})`}
      />
      <XAxisGrid
        ref={xAxisGridRef}
        transform={`translate(0, ${chartHeight - padding})`}
      />
      <YAxis ref={yAxisRef} transform={`translate(${padding}, 0)`} />
      <YAxisGrid ref={yAxisGridRef} transform={`translate(${padding}, 0)`} />
    </g>
  );
};

export default memo(LineChartAxes);
